import React from 'react';
import { Phone, Mail, MapPin, Facebook, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-orange-400 bg-clip-text text-transparent mb-4">
              Dom's Pfotenexpress
            </h3>
            <p className="text-gray-300 mb-4">
              Ihr vertrauensvoller Tier-Taxi Service in Hagen. Wir bringen Ihre Lieblinge sicher und komfortabel ans Ziel.
            </p>
            <div className="flex items-center space-x-2 text-gray-300">
              <Heart className="h-5 w-5 text-red-500 fill-current" />
              <span>Mit Liebe zum Tier seit September 2025</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Schnelllinks</h4>
            <ul className="space-y-2">
              {[
                { label: 'Leistungen', id: 'services' },
                { label: 'Preisrechner', id: 'calculator' },
                { label: 'Termin buchen', id: 'booking' },
                { label: 'Pfotenflatrate', id: 'flatrate' },
                { label: 'Galerie', id: 'gallery' },
                { label: 'Kontakt', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors"
                >
                  <Phone className="h-4 w-4" />
                  <span>{contactInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  <span className="text-sm">{contactInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start space-x-2 text-gray-300">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  {contactInfo.address}<br />
                  {contactInfo.postalCode} {contactInfo.city}
                </span>
              </li>
              <li>
                <a
                  href={`https://facebook.com/${contactInfo.facebook}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors"
                >
                  <Facebook className="h-4 w-4" />
                  <span>Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Emergency Banner */}
        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-6 text-center">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
              <Phone className="h-6 w-6 animate-pulse" />
              <span className="font-bold text-lg">24/7 Notdienst:</span>
              <a
                href={`tel:${contactInfo.phone}`}
                className="text-2xl font-bold hover:underline"
              >
                {contactInfo.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400 text-sm">
          <p>
            © {new Date().getFullYear()} {contactInfo.company} - Inhaber: {contactInfo.owner}
          </p>
          <div className="flex justify-center gap-4 mt-3">
            <Link to="/datenschutz" className="hover:text-white transition-colors">
              Datenschutz
            </Link>
            <span>|</span>
            <Link to="/impressum" className="hover:text-white transition-colors">
              Impressum
            </Link>
            <span>|</span>
            <Link to="/agb" className="hover:text-white transition-colors">
              AGB
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
